/* eslint-disable no-template-curly-in-string */
/* eslint-disable camelcase */
import * as yup from 'yup';
import {
  setLocale,
} from '../../../../../utils/yup-utils';

setLocale();

const validationRules = {
  id_provider: yup.number().nullable(),
  available_from: yup.date().nullable().when('available_to', (available_to, schema) => (available_to ? schema.max(available_to) : schema)),
  available_to: yup.date().nullable().when('available_from', (available_from, schema) => (available_from ? schema.min(available_from) : schema)),
};

const validate = async (form) => {
  const schema = await yup.object().shape(validationRules, ['available_from', 'available_to']);

  try {
    const data = await schema.validate(form, { abortEarly: false });
    return { isValid: true, data, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner) {
      err.inner.forEach((error) => { errors[error.path] = error.message; });
    }
    return { isValid: false, data: form, errors };
  }
};

export default validate;
